import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "item"]

  connect() {
    this.update()
  }

  update() {
    const value = this.sourceTarget.type === "checkbox" ? String(this.sourceTarget.checked) : this.sourceTarget.value
    this.itemTargets.forEach(item => {
      item.hidden = item.dataset.revealWhen !== value
    })
  }
}
